import { useMemo, useState, useEffect } from 'react';
import { useScript, useDeepEffect } from '@financial/common-hooks';
import { SDK_URL } from '../constants/index.mjs';

const now = () => Math.floor(Date.now() / (20 * 60 * 1000));
function usePeriodicVersion() {
  let intervalMinutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  const [version, setVersion] = useState(() => now());
  useEffect(() => {
    const handle = setInterval(() => {
      setVersion(now());
    }, intervalMinutes * 60 * 1000);
    return () => clearInterval(handle);
  }, [intervalMinutes]);
  return version;
}
const useShare = _ref => {
  let {
    profile,
    env,
    pluginConfig,
    elementConfig,
    ref
  } = _ref;
  const {
    current: element
  } = ref;
  const versionQuery = usePeriodicVersion(20);
  const url = useMemo(() => `${SDK_URL[profile][env]}?v=${versionQuery}`, [profile, env, versionQuery]);
  const {
    status
  } = useScript(url);
  const isLoaded = status === 'ready';
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  useEffect(() => {
    if (!element || !isLoaded) {
      return;
    }
    window.__splugin = window.SocialPlugIn_Core(pluginConfig);
    setScriptLoaded(true);
    return () => {
      window.__splugin?.kill(element);
      setScriptLoaded(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element, isLoaded]);
  useDeepEffect(() => {
    if (!isScriptLoaded || !element) {
      return;
    }
    window.__splugin?.update(element, elementConfig);
  }, [elementConfig, isScriptLoaded]);
  return isLoaded;
};

export { useShare };
